import { useState, useCallback } from 'react';
import { Platform } from 'react-native';

type HoverProps = {
  onHoverIn?: () => void;
  onHoverOut?: () => void;
};

export const useHover = (): { isHovered: boolean; hoverProps: HoverProps } => {
  const [isHovered, setIsHovered] = useState(false);

  const onHoverIn = useCallback(() => setIsHovered(true), []);
  const onHoverOut = useCallback(() => setIsHovered(false), []);

  const hoverProps: HoverProps = Platform.OS === 'web'
    ? { onHoverIn, onHoverOut }
    : {};

  return { isHovered, hoverProps };
};
